import * as React from 'react';

import HeaderPanel from './components/HeaderPanel';
import {getServerTexts as getSaveStatusTexts} from './components/SaveStatus/texts';
import {getServerTexts as getFiltersTexts} from '../Filters/texts';
import {getServerTexts as getQuickSearchTexts} from '../QuickSearch/text';

export function renderHeaderPanel(root, props: any) {
    getSaveStatusTexts();
    getFiltersTexts();
    getQuickSearchTexts();

    root.render(<HeaderPanel {...props} />);
}
